import { render, staticRenderFns } from "./CarbonOffsetExisting.vue?vue&type=template&id=8fda7b0c&scoped=true"
import script from "./CarbonOffsetExisting.vue?vue&type=script&lang=js"
export * from "./CarbonOffsetExisting.vue?vue&type=script&lang=js"
import style0 from "./CarbonOffsetExisting.vue?vue&type=style&index=0&id=8fda7b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fda7b0c",
  null
  
)

export default component.exports